module.exports = __webpack_public_path__ + "media/images/ios2-117b87026b7a355c7dda565e250b9590.png";